import { render, staticRenderFns } from "./BidResultList.vue?vue&type=template&id=a8518cb4&scoped=true&"
import script from "./BidResultList.vue?vue&type=script&lang=js&"
export * from "./BidResultList.vue?vue&type=script&lang=js&"
import style0 from "./BidResultList.vue?vue&type=style&index=0&id=a8518cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8518cb4",
  null
  
)

export default component.exports